import { Component, OnInit } from '@angular/core';
import { NodeService } from '../../services/node-service/node-service.service';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  standalone: false,
})
export class EditCategoryComponent implements OnInit {
  title: string = 'Editar categoría';

  constructor(
    private nodeService: NodeService,
    private subcategoryService: SubcategoryService,
    private rootcategoriesService: RootcategoriesService
  ) {}

  ngOnInit(): void {
    const categoryId = this.nodeService.getCategoryId();

    this.subcategoryService.getCategory(categoryId).subscribe({
      next: ({ body }) => {
        const category = body.category;
        this.title = `Editar ${category?.nombre}`;
      },
      error: () => {
        this.rootcategoriesService.openSnacBar('Ha ocurrido un error');
      },
    });
  }
}
